export function getOrDefault<T>(value: T | null | undefined, defaultValue: T): T {
	if (value === null || value === undefined) {
		return defaultValue;
	}
	if (typeof value === 'number' && isNaN(value)) {
		return defaultValue;
	}
	return value;
}
